import { libraryConstants } from '../_constants';

export function library(state = {}, action) {
  switch (action.type) {
    case libraryConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case libraryConstants.GETALL_SUCCESS:
      return {
        libraries: action.libraries
      };
    case libraryConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };

      case libraryConstants.GETBYUSERROLE_REQUEST:
      return {
        loading: true
      };
    case libraryConstants.GETBYUSERROLE_SUCCESS:
      return {
        getByUserRole: action.libraries
      };
    case libraryConstants.GETBYUSERROLE_FAILURE:
      return { 
        error: action.error
      };


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/library.reducer.js